import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuthHeaders } from '../utils/authHeaders';

const PayrollList = () => {
    const companyId = localStorage.getItem('selectedCompanyId');
    const authConfig = () => ({ headers: getAuthHeaders() });
    const [payrolls, setPayrolls] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);
    const [error, setError] = useState(null);

    // Form state
    const [employeeId, setEmployeeId] = useState('');
    const [periodStart, setPeriodStart] = useState('');
    const [periodEnd, setPeriodEnd] = useState('');
    const [overtimeHours, setOvertimeHours] = useState(0);
    const [overtimePay, setOvertimePay] = useState(0);

    const fetchAll = async () => {
        try {
const [payrollRes, empRes] = await Promise.all([
    axios.get(`http://localhost:8000/api/companies/${companyId}/payrolls`, authConfig()),
    axios.get(`http://localhost:8000/api/companies/${companyId}/employees`, authConfig())
]);
            setPayrolls(payrollRes.data.data);
            setEmployees(empRes.data.data);
            if (empRes.data.data.length > 0) setEmployeeId(empRes.data.data[0].id);
        } catch (err) {
            setError('Failed to fetch payroll data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId]);

    const handleGenerate = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`http://localhost:8000/api/companies/${companyId}/payrolls`, {
                employee_id: employeeId,
                pay_period_start: periodStart,
                pay_period_end: periodEnd,
                overtime_hours: overtimeHours,
                overtime_pay: overtimePay
            }, authConfig());
            setPeriodStart('');
            setPeriodEnd('');
            setOvertimeHours(0);
            setOvertimePay(0);
            fetchAll();
            alert('Payroll record generated!');
        } catch (err) {
            alert(err.response?.data?.message || 'Error generating payroll record.');
        }
    };

    if (initialLoading) return <div className="p-6 text-center text-gray-600">Loading payroll...</div>;
    if (error) return <div className="p-6 text-center text-red-600">{error}</div>;

    return (
        <div className="max-w-6xl mx-auto p-6 mt-10">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payroll</h2>
            <p className="text-sm text-gray-500 mb-6">
                Pay is calculated automatically from the employee's HR Profile compensation type, attendance, and payroll settings. Overtime hours (Hourly employees) or a manual overtime amount (Monthly employees) can be added below.
            </p>

            {/* Generation Form */}
            <form onSubmit={handleGenerate} className="bg-white p-6 rounded-lg shadow-md mb-8 grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Employee</label>
                    <select
                        value={employeeId}
                        onChange={(e) => setEmployeeId(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md p-2 text-sm bg-white"
                    >
                        {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>{emp.first_name} {emp.last_name}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Period Start</label>
                    <input
                        type="date"
                        value={periodStart}
                        onChange={(e) => setPeriodStart(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md p-2 text-sm"
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Period End</label>
                    <input
                        type="date"
                        value={periodEnd}
                        onChange={(e) => setPeriodEnd(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-md p-2 text-sm"
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Overtime Hours (Hourly employees)</label>
                    <input
                        type="number"
                        step="0.5"
                        value={overtimeHours}
                        onChange={(e) => setOvertimeHours(e.target.value)}
                        className="w-full border border-gray-300 rounded-md p-2 text-sm"
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Overtime Pay (Monthly employees)</label>
                    <input
                        type="number"
                        step="0.01"
                        value={overtimePay}
                        onChange={(e) => setOvertimePay(e.target.value)}
                        className="w-full border border-gray-300 rounded-md p-2 text-sm"
                    />
                </div>
                <div>
                    <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 text-sm font-medium">
                        Generate Payroll
                    </button>
                </div>
            </form>

            {/* Payroll Table */}
            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Period</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Basic</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Allowances</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Overtime</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deductions</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Net</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {payrolls.length === 0 ? (
                            <tr>
                                <td colSpan="8" className="px-6 py-4 text-center text-gray-500">No payroll records yet.</td>
                            </tr>
                        ) : (
                            payrolls.map((p) => (
                                <tr key={p.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{p.employee ? `${p.employee.first_name} ${p.employee.last_name}` : 'N/A'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{p.pay_period_start} → {p.pay_period_end}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">${Number(p.basic_salary).toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">${Number(p.allowances).toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">${Number(p.overtime_pay).toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">${Number(p.deductions).toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">${Number(p.net_salary).toLocaleString()}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                            p.status === 'Draft' ? 'bg-yellow-100 text-yellow-800' :
                                            p.status === 'Paid' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                                        }`}>
                                            {p.status}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PayrollList;